import React, { ReactElement } from "react";
import classnames from "classnames";

import "./style.scss";

const blockName = "SvgImage";

interface SvgImageProps {
  imageHash: {
    id: string;
  };
  height?: number;
  width?: number;
  customClassName?: string;
}

function SvgImage(props: SvgImageProps): ReactElement {
  const {
    imageHash,
    width,
    height,
    customClassName
  } = props;
  const svgProps: {width?: number; height?: number; viewBox?: string} = {};

  if (width !== null) {
    svgProps.width = width;
  }

  if (height !== null) {
    svgProps.height = height;
  }

  if (width !== null && height !== null) {
    svgProps.viewBox = `0 0 ${width} ${height}`;
  }

  return (
    <svg
      className={classnames(
        blockName,
        {
          [customClassName]: customClassName
        }
      )}
      {...svgProps}
    >
      <use href={`#${imageHash.id}`} />
    </svg>
  );
}

SvgImage.defaultProps = {
  customClassName: null,
  height: null,
  width: null
};

export default SvgImage;
